import { useDispatch } from "react-redux";
import { useLazyGetFaqQuery } from "../../../Store/Builder/techsbook.api";
import showToast from "../../Hooks/toast";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import { useState } from "react";

const useFaq = (page) => {
  const dispatch = useDispatch();
  const [getFaq] = useLazyGetFaqQuery();

  const [faq, setFaq] = useState([]);

  const formatParams = () => {
    const pageParam = `${page ? '&' : ''}page=${page}`;
    return `${pageParam ? pageParam : ''}`;
  }

  const get = () => {
    dispatch(setLoader(true));
    const formattedParams = formatParams();
    getFaq(formattedParams)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        setFaq(res);
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    get,
    faq,
  };
};

export default useFaq;
